import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

export const post = (param) => {
  const resource = Vue.resource(
    param.path,
    null,
    null,
    { uploadProgress: param.progress, before: param.before }
  )

  return resource.save(param.data)
}

export const get = (param) => {
  const resource = Vue.resource(param.path)
  delete param.path
  // If a specifc item needs to be loaded
  if (param.data && param.data.id) {
    return resource.get({ id: param.data.id, params: param.params })
  }

  return resource.get(param)
}

export const getWithOpts = (param) => {
  // This way options like "responseType" are used properly (e.g. used to download files)
  return Vue.http.get(param.path, param.opts)
}

export const put = (param) => {
  const resource = Vue.resource(param.path)

  if (!param.data) {
    throw new Error('Model data for saving expected')
  }

  return resource.update(param.data)
}

export const destroy = (param) => {
  const resource = Vue.resource(param.path)

  return resource.delete({}, param.data)
}



// WEBPACK FOOTER //
// ./src/store/api.js